module.exports = {"421181001":"龙池桥街道","421181002":"鼓楼街道","421181003":"南湖街道","421181100":"中馆驿镇","421181101":"宋埠镇","421181102":"歧亭镇","421181103":"白果镇","421181104":"夫子河镇","421181105":"阎家河镇","421181106":"龟山镇","421181107":"盐田河镇","421181108":"张家畈镇","421181109":"木子店镇","421181110":"三河口镇","421181111":"黄土岗镇","421181112":"福田河镇","421181113":"乘马岗镇","421181114":"顺河镇","421181200":"铁门岗乡","421181401":"宋埠良种场","421181402":"麻城明山水库","421181403":"麻城三河水库","421181404":"国营狮子峰林场","421181405":"麻城林店茶场","421181471":"湖北麻城经济开发区","421181472":"龟峰山风景区管理处","421181473":"浮桥河国家湿地公园管理处","421181500":"五脑山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421181.json
// module id = 1905
// module chunks = 0